export default __webpack_public_path__ + "static/media/hedil.934b7fdb.png";